import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import {
  deleteCasePublicAuthorityQuery,
  fetchCasePublicAuthoritiesQuery,
} from 'app/edozvola/cases/special-regulations-compliance/service/special-regulations-compliance.queries';
import { CasePublicAuthorityViewModel } from 'app/edozvola/cases/special-regulations-compliance/model/special-regulations-compliance.model';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

const CasePublicAuthorityTable = ({ setCasePublicAuthority, setReadOnly }) => {
  const { id: uuid } = useParams<{ id: string }>();
  const [idPublicAuthorityToDelete, setIdPublicAuthorityToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.CASE_PUBLIC_AUTHORITY_TABLE);

  const { mutate: deletePublicAuthority, isPending: deletingPublicAuthority } = deleteCasePublicAuthorityQuery();

  const openCasePublicAuthorityForm = (idCasePublicAuthority: number, readOnly: boolean) => {
    setCasePublicAuthority(idCasePublicAuthority);
    setReadOnly(readOnly);
  };

  const openDeleteDialog = idToDelete => {
    setIdPublicAuthorityToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const removeCasePublicAuthority = () => {
    setDeleteModalShown(false);
    deletePublicAuthority(idPublicAuthorityToDelete);
  };

  const renderTableRow = (value: CasePublicAuthorityViewModel, casePublicAuthorityIndex: number, totalItems: number) => {
    return (
      <tr key={casePublicAuthorityIndex} className={invalidRowIds.includes(value.idCasePublicAuthority) ? 'invalid-table-row' : ''}>
        <td>{value.value}</td>
        <td>{value.address}</td>
        <td>{value.idJpt}</td>
        <td>{value.authorityDidAnswer ? value.jptAnswer : 'Javnopravno tijelo se nije odazvalo pozivu.'}</td>
        <td>{value.litigation}</td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canView && (
              <TooltipWrapper message={'Pregledaj'}>
                <FontAwesomeIcon
                  icon={'eye'}
                  className={'icon-table'}
                  onClick={() => openCasePublicAuthorityForm(value.idCasePublicAuthority, true)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canEdit && (
              <TooltipWrapper message={'Uredi'}>
                <FontAwesomeIcon
                  icon={'pen-to-square'}
                  className={'icon-table'}
                  onClick={() => openCasePublicAuthorityForm(value.idCasePublicAuthority, false)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon
                  icon={'trash-alt'}
                  className={'icon-table'}
                  onClick={() => openDeleteDialog(value.idCasePublicAuthority)}
                />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema javnopravnih tijela.'}
        initialPaginationColumn={'ordering'}
        fetchDataQuery={fetchCasePublicAuthoritiesQuery}
        fetchDataProps={[uuid]}
      >
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Naziv javnopravnog tijela']} width={'200px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Adresa']} width={'200px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['ID JPT']} width={'100px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Odgovor JPT-a']} width={'400px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Spor']} width={'75px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'120px'} />
      </ViewTable>
      <Modal isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje javnopravnog tijela</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} color={'secondary'} />
          <Button size={'lg'} label="Obriši" onClick={removeCasePublicAuthority} color={'danger'} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CasePublicAuthorityTable;
